export const ROW_ACTIONS_CONFIG = {
  getOnClickProps: item => item,
}

export const DocFlowUploadingTableCellName = {
  Name: 'name',
  PagesCount: 'pages_count',
  Type: 'type',
  Uploaded: 'uploaded',
  UploadedBy: 'uploaded_by',
}
